import { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Collapse } from "reactstrap";
// componentes
import SectionComponent from "../../../Apps/Personalization/SectionComponent";
import ImportCreateGroup from "./ImportCreate";
import ImportDeleteGroup from "./ImportDelete";
import ImportUpdateGroup from "./ImportUpdate";

export default function ModalAllImports(props) {
  const { toggle, isOpen, idEvent, getGroupsFunc } = props;
  // collapse
  const [collapseCreate, setCollapseCreate] = useState(false);
  const [collapseUpdate, setCollapseUpdate] = useState(false);
  const [collapseDelete, setCollapseDelete] = useState(false);

  function toggleCollapseCreate() {
    setCollapseCreate(!collapseCreate);
    setCollapseUpdate(false);
    setCollapseDelete(false);
  }

  function toggleCollapseUpdate() {
    setCollapseCreate(false);
    setCollapseUpdate(!collapseUpdate);
    setCollapseDelete(false);
  }

  function toggleCollapseDelete() {
    setCollapseCreate(false);
    setCollapseUpdate(false);
    setCollapseDelete(!collapseDelete);
  }

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Importadores de Grupos</ModalHeader>

        <ModalBody>
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Adicionar Grupos"
              setIsOpen={toggleCollapseCreate}
              isOpen={collapseCreate}
            />
          </Row>
          <Collapse isOpen={collapseCreate}>
            <ImportCreateGroup
              toggleModal={toggle}
              idEvent={idEvent}
              getGroupsFunc={getGroupsFunc}
            />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Editar Grupos"
              setIsOpen={toggleCollapseUpdate}
              isOpen={collapseUpdate}
            />
          </Row>
          <Collapse isOpen={collapseUpdate}>
            <ImportUpdateGroup
              toggleModal={toggle}
              idEvent={idEvent}
              getGroupsFunc={getGroupsFunc}
            />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Excluir Grupos"
              setIsOpen={toggleCollapseDelete}
              isOpen={collapseDelete}
            />
          </Row>
          <Collapse isOpen={collapseDelete}>
            <ImportDeleteGroup
              toggleModal={toggle}
              idEvent={idEvent}
              getGroupsFunc={getGroupsFunc}
            />
          </Collapse>
        </ModalBody>
      </Modal>
    </>
  );
}
